import { createSlice } from '@reduxjs/toolkit';
import { setAuthHeader } from '../../utils/axiosHeaders';
import { User } from 'oidc-client';
import { AppDispatch } from '../../store';
export interface ContextualHelpState {
  isContextualHelp: boolean;
}
const initialState: ContextualHelpState = {
  isContextualHelp: false,
};
const contextualHelpSlice = createSlice({
  name: 'contextualHelp',
  initialState,
  reducers: {
    toogleContextualHelp: (state, action: { type: string; payload: boolean }) => {
      return { ...state, isContextualHelp: action.payload };
    },
  },
});
export const contextualHelpActions = { ...contextualHelpSlice.actions };
export default contextualHelpSlice;
